import { render, staticRenderFns } from "./IconZoomImg.vue?vue&type=template&id=5242f6a8&scoped=true&"
import script from "./IconZoomImg.vue?vue&type=script&lang=js&"
export * from "./IconZoomImg.vue?vue&type=script&lang=js&"
import style0 from "./IconZoomImg.vue?vue&type=style&index=0&id=5242f6a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5242f6a8",
  null
  
)

export default component.exports